<template>
    <div class="shadow-lg rounded-md overflow-hidden max-w-7xl mx-auto">
        <div class="flex items-center gap-4 bg-primary-light py-4 md:py-6 px-12 justify-center relative text-center">
            <span class="absolute left-4 h-6 w-6 md:w-10 md:h-10 rounded-full bg-primary-dark text-white flex items-center justify-center text-base md:text-2xl font-bold">
                {{step}}
            </span>
            <span class="font-bold text-normal md:text-xl text-primary-dark">
                {{title}}
            </span>
        </div>
        <div class="md:p-10 px-2 py-4 bg-gray-100">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        step: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            default: "Merci d'indiquer un titre"
        }
    }
}
</script>

<style lang="scss" scoped>

</style>